export const environment = {
  production: false,
  hmr: true,
  buildVersion: 'dev-' + Date.now(), // For development, changes on each reload
  apiUrl: 'https://dev-api.peopleflow.sk/',
  openApiUrl: 'https://dev-api.peopleflow.sk/openapi/',
  // apiUrl: 'http://localhost:1212/',
  // openApiUrl: 'http://localhost:1213/openapi/',
  dashboardUrl: 'https://dev-app.peopleflow.sk/',
  googleMapsApiKey: '',
  firebase: {
    apiKey: 'AIzaSyDmap5Zxy8TFCGMNLZp46juVbRSb6L4I5M',
    authDomain: 'sameta-jobs-dev.firebaseapp.com',
    projectId: 'sameta-jobs-dev',
    storageBucket: 'sameta-jobs-dev.firebasestorage.app',
    messagingSenderId: '1052385804747',
    appId: '1:1052385804747:web:27605d049ce8744ff9f64e',
  },
  legal: {
    termsOfUseUrl: '/terms-of-use',
    privacyPolicyUrl: '/privacy-policy',
  },
};
